import React, { useContext } from "react";
import crossIcon from "../../Assets/closeIcon.svg";
import { ShowProfileContext } from "../../Contexts/showProfileContext";

const ErrorPopup = ({ error, onClose }) => {
  const { showProfile } = useContext(ShowProfileContext);

  const errorMessage =
    typeof error === "string"
      ? error
      : error?.message || "Something went wrong.";

  const isProfileError =
    errorMessage ===
    "Please complete your profile before applying for this job.";

  const isMaxApplicantsError =
    /maximum number of applicants|max(imum)? applicants/i.test(errorMessage);

  const handleEditProfile = () => {
    showProfile();
    onClose();
  };

  const popupTitle = isProfileError
    ? "Complete Your Profile"
    : isMaxApplicantsError
      ? "Maximum Applicants Reached"
      : "Unable to Continue";

  return (
    <div className="fixed top-0 right-0 left-0 bottom-0 flex items-center justify-center p-4 bg-popup-bg-color backdrop-blur-[2px] z-[--after-registration-popup]">
      <div className="bg-white w-full md:w-96 rounded-xl p-6 relative">
        <img
          src={crossIcon}
          alt="Close"
          className="absolute top-4 right-4 cursor-pointer w-6"
          onClick={onClose}
        />

        <div className="flex flex-col items-center gap-4 mt-2">
          <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
            <span className="text-red-600 text-xl">⚠</span>
          </div>

          <h3 className="font-semibold text-lg text-center">{popupTitle}</h3>

          <p className="text-gray-600 text-center text-sm">{errorMessage}</p>

          <div className="flex gap-3 w-full mt-2">
            <button
              onClick={onClose}
              className="flex-1 py-2 px-4 border border-gray-300 rounded-full font-medium hover:bg-gray-50 transition-all duration-300"
            >
              {isProfileError ? "Cancel" : "Close"}
            </button>

            {isProfileError && (
              <button
                onClick={handleEditProfile}
                className="flex-1 py-2 px-4 bg-primary-color-900 text-white rounded-full font-medium hover:brightness-90 transition-all duration-300"
              >
                Edit Profile
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorPopup;
